import { Link } from 'react-router-dom';

export default function MentoringVsAdaptation() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Наставничество и адаптация — в чём разница
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Эти процессы часто путают, хотя они решают разные задачи
        </p>

        <div className="grid sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8 hover:border-teal-300 transition-colors">
            <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
              <i className="ri-compass-3-line text-teal-700 text-lg"></i>
            </div>
            <h3 className="font-bold text-gray-900 text-sm mb-2">Адаптация</h3>
            <p className="text-gray-600 text-xs leading-relaxed">
              Помогает новому сотруднику войти в компанию и освоиться в новой роли: понять правила, стандарты, культуру и задачи должности.
            </p>
          </div>
          <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8 hover:border-teal-300 transition-colors">
            <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
              <i className="ri-plant-line text-teal-700 text-lg"></i>
            </div>
            <h3 className="font-bold text-gray-900 text-sm mb-2">Наставничество</h3>
            <p className="text-gray-600 text-xs leading-relaxed">
              Помогает развивать профессиональные навыки и самостоятельность: передача опыта, постановка развивающих задач и рост компетенций.
            </p>
          </div>
        </div>

        <div className="mt-10 bg-white rounded-xl border border-gray-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-sm text-gray-600 leading-relaxed">
            Адаптация и наставничество могут работать вместе, но не являются одним и тем же процессом. Подробнее о вводе новых сотрудников — на странице{' '}
            <Link to="/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
              «Адаптация сотрудников»
            </Link>.
          </p>
        </div>
      </div>
    </section>
  );
}